
'use strict'

import Input from "../../utils/Input";
import CustomSelect from "../../utils/CustomSelect";

class ContactUs{
    constructor(){
        this.main = document.getElementById('contact_us');
        
        this._inputName = new Input(this.main.querySelector('input[name="name"]'));
        this._inputEmail = new Input(this.main.querySelector('input[name="email"]'));
        this._inputPhone = new Input(this.main.querySelector('input[name="phone"]'));
        this._inputMessage = new Input(this.main.querySelector('textarea[name="message"]'));
        
        this._sendBtn = this.main.querySelector('.send_btn');
        
        this._sending = false;

        this._sendBtn.addEventListener('click', this._onClickSendBtn.bind(this));
    }

    _onClickSendBtn(e){
        e.preventDefault();
        
        if(!this._sending){
            let formOk = true;
            let recaptchaHash=grecaptcha.enterprise.getResponse();

            if(this._inputName.isEmpty){
                formOk = false;
                this._inputName.error = true;
            }else{
                this._inputName.error = false;
            }

            if(!this._inputEmail.isValidEmail){
                formOk = false;
                this._inputEmail.error = true;
            }else{
                this._inputEmail.error = false;
            }

            if(this._inputPhone.isEmpty || !this._inputPhone.isValidPhone){
                formOk = false;
                this._inputPhone.error = true;
            }else{
                this._inputPhone.error = false;
            }

            if(this._inputMessage.isEmpty){
                formOk = false;
                this._inputMessage.error = true;
            }else{
                this._inputMessage.error = false;
            }
            
            if(recaptchaHash==''){
                formOk = false;
                document.getElementById('recaptcha_box').classList.add('form__group--error');
            }else{
                document.getElementById('recaptcha_box').classList.remove('form__group--error');
            }
            
            if(formOk){
                let requestData = {
                    name: this._inputName.value,
                    email: this._inputEmail.value,
                    phone: this._inputPhone.value,
                    message: this._inputMessage.value,
                    lang: App.lang,
                    recaptchaToken: recaptchaHash
                }

                this._sending = true;
                this._sendBtn.classList.add('btn--loading');

                fetch(App.baseUrl + 'contact-us/contact', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache'
                    },
                    body: JSON.stringify(requestData)
                })
                .then((response) => {return response.json()})
                .then((data) => {
                    this._sending = false;
                    this._sendBtn.classList.remove('btn--loading');

                    if(!data.error){
                        App.alertMessage.show(this.main.getAttribute('data-msg-success'), true);
                        this._resetFields();
                    }else{
                        App.alertMessage.show(this.main.getAttribute('data-msg-error-server'));        
                    }
                });


            }else{
                App.alertMessage.show(this.main.getAttribute('data-msg-error-fields'));
            }
        }
    }

    _resetFields(){
        this._inputName.reset();
        this._inputEmail.reset();
        this._inputPhone.reset();
        this._inputMessage.reset();
        grecaptcha.enterprise.reset();
    }
}

export default ContactUs;
